function getUtcMidnight(value) {
  const utcValue = new Date(
    Date.UTC(value.getFullYear(), value.getMonth(), value.getDate())
  );
  return utcValue;
}

export default getUtcMidnight;
